<template>
  <!-- <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    v-bind="$attrs"
    :key="modelDate"
  >
    <template v-slot:activator="{ on }">
      <MaskedTextField
        :inputData.sync="maskedModelDate"
        mask-type="datetime"
        :label="label"
        v-bind="$attrs"
        @update:inputData="setModelDate"
        @blur="lostFocus"
      >
        <template slot="prependMask">
          <v-icon v-on="on">mdi-calendar</v-icon>
        </template>

        <template v-if="hasTodayButton" slot="appendMask">
          <v-icon @click="setToday">mdi-bookmark</v-icon>
        </template>
      </MaskedTextField> -->

      <!-- <v-text-field
        :value="modelDate | formatDate"
        :label="label"
        
        v-bind="$attrs"
      >
        <template v-slot:prepend>
          <v-icon v-on="on">mdi-calendar</v-icon>
        </template>
      </v-text-field> -->
    <!-- </template> -->
    <!-- <v-date-picker
      v-model="modelDate"
      @input="change"
      locale="pt-br"
      okText="Confirmar"
      clearText="Limpar"
    /> -->
    <v-datetime-picker 
      v-model="modelDate"
      :time-picker-props="timeProps"
      time-format="HH:mm"
      date-format="dd/MM/yyyy"
      :label="label"
      v-bind="$attrs"
      clearText="Limpar"
      okText="Confimar"
      @input="emitDateChange"
    >
      <template v-slot:dateIcon>
        <v-icon >mdi-calendar</v-icon>
      </template>
      <template v-slot:timeIcon>
        <v-icon >mdi-clock-outline</v-icon>
      </template>
    </v-datetime-picker>
  <!-- </v-menu> -->
</template>

<script>
// https://github.com/darrenfang/vuetify-datetime-picker/blob/master/src/components/DatetimePicker.vue
import moment from "moment";
import MaskedTextField from "@shared_components/masked_text_field.vue"

 export default {
  data () {
    return { 
      dateMenu: false,
      modelDate: null,
      maskedModelDate: null,
      todayDate: moment().toDate(),
      timeProps: {
        format: "24hr"
      }
   }
  },
  components: {
    MaskedTextField: MaskedTextField,
  },
  props: {
    inputData: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "Data"
    },
    hasTodayDate: {
      type: Boolean,
      default: false
    },
    hasTodayButton: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.hasTodayDate && !this.inputData) {
      this.modelDate = this.todayDate;
      this.emitDateChange();
    } else {
      if(this.inputData){
        this.modelDate = moment(this.inputData).toDate();
      }
    }
    // console.log("this.modelDate", this.modelDate);
  },
  methods: {
    emitDateChange: function() {
      // console.log("this.modelDate", this.modelDate);
      let dateTimeToEmit =  moment(this.modelDate).utc().format();
      // console.log("dateTimeToEmit", dateTimeToEmit);
      this.$emit('update:inputData', dateTimeToEmit);
    },
  },
 }
</script>

<style scoped>
</style>
